import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';

@Component({
  selector: 'app-homehunt-area-not-covered',
  templateUrl: './homehunt-area-not-covered.component.html',
  styleUrls: ['./homehunt-area-not-covered.component.scss'],
})
export class HomehuntAreaNotCoveredComponent implements OnInit {
  constructor(public appState: AppState) {}
  @Input() data;
  companyInfo: any = {};
  // Subscriptions to unsubscribe on component destroy
  onDestroyNotifier$ = new Subject();

  ngOnInit() {
    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res && Object.keys(res).length) {
        this.companyInfo = res;
      }
    });
  }

  ngOnDestroy(): void {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
